var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aaaaaa",style:(_vm.mys)},_vm._l((_vm.current),function(item,index){return _c('important2',{key:item.version+'_'+index,tag:"div",attrs:{"dataAll":{current:item}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }